<template>
  <div class="pdt-20px">
    <div class="card">
      <header class="header-card" >
        <p>{{ $t('general.informationGeneral')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field :label="$t('ajoutDevis.etatSuivi.dateTransmissionAuClub')">
              <b-datepicker
                v-model="dcf.dateTransmissionAuClub"
                :disabled="!isEdit"
                :editable="true"
                icon="calendar-today"
                nearby-selectable-month-days
                show-week-number>
              </b-datepicker>
              <p class="mgl-10px">
                <qd-checkbox
                  v-model="dcf.transmissionAuClub"
                  class="mgt-7px"
                  :disabled="!isEdit">
                  <span class="label">{{ $t('ajoutDevis.etatSuivi.transmissionAuClub') }}</span>
                </qd-checkbox>
              </p>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('ajoutDevis.etatSuivi.dateTransmissionAuClient')">
              <b-datepicker
                v-model="dcf.dateTransmissionAuClient"
                :disabled="!isEdit"
                :editable="true"
                icon="calendar-today"
                nearby-selectable-month-days
                show-week-number>
              </b-datepicker>
              <p class="mgl-10px">
                <qd-checkbox
                  v-model="dcf.transmissionAuClient"
                  class="mgt-7px"
                  :disabled="!isEdit">
                  <span class="label">{{ $t('ajoutDevis.etatSuivi.transmissionAuClient') }}</span>
                </qd-checkbox>
              </p>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <liste-etat-suivi-devis-commande
      v-model="dcf.etatSuivis"
      :isEdit="isEdit"
    />
  </div>
</template>

<script>
import ListeEtatSuiviDevisCommande from '@/components/devisCommandes/presse/etatSuiviDevisCommande/listeEtatSuiviDevisCommande';

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    ListeEtatSuiviDevisCommande,
  },
  computed: {
    dcf: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emait('input', newVal);
      },
    },
  },
};
</script>
